import React from 'react';

export const newLine = (content, property) => {
    const p = content[property];
    const split = p.split('<br />');
    content[property] =
        split.slice(0, -1).map((e, i) =>
            <span key={i}>{e} <br /></span>
        ).concat(split.pop());
}

export const breakLine = (info) => {
    if (info && info.indexOf('\n') !== -1) {
        let newText = info.split('\n').map((text, i) => {
            return <React.Fragment key={i}>{text}<br /></React.Fragment>
        });

        return newText
    }

    return info;
}